export enum GlobalSearchResultType {
  PROFESSION,
  PROFESSION_APPRENTICESHIP,
  COMPANY,
  SCHOOL,
  INSTITUTION,
  DAILY_ROUTINE,
  SCHOOL_PORTRAIT,
  VR_VIDEO,
  APPRENTICESHIP,
  HOLIDAY_JOB,
  INTERNSHIP
}
